module.exports = __webpack_public_path__ + "assets/warning_icn@1x.5bbe81a6.svg";